<template>
    <div class="my-10">
        <MyBusinessAccountsNav></MyBusinessAccountsNav>
        <div class="grid grid-cols-4 gap-4 max-lg:grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1">
            <router-link :to="{ name: 'viewMyBusinessAccount', params: { id: item.id } }" v-for="item in accounts" :key="item.id">
                <MyBusinessAccountCard :detail="item">
                </MyBusinessAccountCard>
            </router-link>
            <div v-show="accounts.length === 0 && loading === false">
                <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
            </div>

        </div>
        <div v-show="loading === true" class="flex justify-center mt-10" role="status">
            <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
            </IconSpinner>

            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import MyBusinessAccountsNav from '@cmp/businessProfile/MyBusinessAccountsNav.vue'
import BusinessAccountCard from '@cmp/media/BusinessAccountCard.vue'
import MyBusinessAccountCard from '@cmp/MyBusinessAccountCard.vue'
export default{
    name: "MyBusinessAccounts",
    components: {
        MyBusinessAccountsNav,
        BusinessAccountCard,
        MyBusinessAccountCard
    },
    data(){
        return {
            loading: false,
            accounts: []
        }
    },
    methods: {
        async getAccounts() {
            this.loading = true
            try {
                const response = await api.get('posts/my-business-accounts/')
                this.accounts = response.data.results
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
    },
    created(){
        this.getAccounts()
    }
}
</script>